import PlayerTransferHistoryContainer from 'containers/PlayerTransferHistory'
import React from 'react'

const PlayerTransferHistory = () => <PlayerTransferHistoryContainer />

export default PlayerTransferHistory
